// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3fuwA","remove-underline":"Footer_remove-underline__2Lh4k"};